<template>
	<div>
		<v-container pa-0 fluid grid-list-md>
			<v-data-iterator
				row wrap
				:items="jobs"
				:rows-per-page-items="[10]"
				:total-items="pagination.totalItems"
				:pagination.sync="pagination"
				next-icon="arrow_forward_ios"
				prev-icon="arrow_back_ios"
				content-tag="v-layout">
				<v-flex
					xs12 sm6 md4 lg3
					slot="item"
					slot-scope="props">
					<v-card
						:class="hasViewed(props.item.viewed_status)"
						@click.stop="loadJobRequest(props.item)">
						<v-card-title
                            :class="(props.item.is_archived) ? 'archived' : ''"
                        >
							<h4>
								<a class="break">{{ props.item.name }}</a>
								<span v-if="props.item.priority || props.item.is_24_hour_rush" class="rush-item">{{getJobPriority(props.item)}}</span>
							</h4>
						</v-card-title>
						<v-divider></v-divider>
						<v-list dense>
							<v-list-tile>
								<v-list-tile-content>Status:</v-list-tile-content>
								<v-list-tile-content class="align-end">{{ getJobEnumItemValue('jobStatuses', props.item.status, 'name') }}</v-list-tile-content>
							</v-list-tile>
                            <v-list-tile>
                                <v-list-tile-content>Department:</v-list-tile-content>
                                <v-list-tile-content class="align-end">{{ getJobEnumItemValue('jobDepartments', props.item.department, 'abbreviation') }}</v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile>
                                <v-list-tile-content>Type:</v-list-tile-content>
                                <v-list-tile-content class="align-end">{{ getJobEnumItemValue('jobTypes', props.item.type, 'name') }}</v-list-tile-content>
                            </v-list-tile>
							<v-list-tile>
								<v-list-tile-content>Requestor:</v-list-tile-content>
								<v-list-tile-content class="align-end">{{ props.item.requestor | f__displayName }}</v-list-tile-content>
							</v-list-tile>
							<v-list-tile>
								<v-list-tile-content>Submitted:</v-list-tile-content>
								<v-list-tile-content class="align-end">{{ displayData(props.item.state, props.item.date_submitted) | f__twoDigitMonthDay }}</v-list-tile-content>
							</v-list-tile>
							<!-- <v-list-group>
								<v-list-tile>
									<v-list-tile-content>First Comp:</v-list-tile-content>
									<v-list-tile-content class="align-end">{{ displayData(props.item.state, props.item.date_first_comp) | f__twoDigitMonthDay}}</v-list-tile-content>
								</v-list-tile>
								<v-list-tile>
									<v-list-tile-content>Delivery:</v-list-tile-content>
									<v-list-tile-content class="align-end">{{ displayData(props.item.state, props.item.date_delivery) | f__twoDigitMonthDay }}</v-list-tile-content>
								</v-list-tile>
							</v-list-group> -->
						</v-list>
					</v-card>

				</v-flex>
                <template slot="no-data">
                    <div class="view-global-loading" v-if="viewLoaded==false">
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                    </div>
                    <div class="view-global-nodata" v-else>No Results Found</div>
                </template>
			</v-data-iterator>
		</v-container>

	</div>
</template>


<script>
	import { mapState, mapGetters, mapActions } from 'vuex'
	import { VDataIterator } from 'vuetify'

	import {
		VUEX_JOB_GET_REQUEST,
		VUEX_JOBS_SYNC_PAGINATION
	} from '@/store/constants/jobs'

	export default {
		name: 'jobs-center-cards',

		data:() => ({
			items:[]
		}),

		components: {
			'v-data-iterator': VDataIterator
		},

		computed: {
			...mapState({
				jobs: state => state.jobs.jobs,
				jobCodes: state => state.properties.jobCodes,
				jobCreativeRounds: state => state.properties.jobCreativeRounds,
				jobDepartments: state => state.properties.jobDepartments,
				jobFlags: state => state.properties.jobFlags,
				jobsPagination: state => state.jobs.pagination,
				jobPriorities: state => state.properties.jobPriorities,
				jobProgresses: state => state.properties.jobProgresses,
				jobProgressNotes: state => state.properties.jobProgressNotes,
				jobStatuses: state => state.properties.jobStatuses,
				jobTypes: state => state.properties.jobTypes,

                viewLoaded: state => state.jobs.jobsLoaded,
			}),
			displayData() {
				return (state, date) => {
					return state !== 'draft' ? date : null
				}
			},

			...mapGetters({
				currentJobId: 'getJobId',
				currentUserHasPerm: 'currentUserHasPerm',
				getJobEnumItemValue: 'getJobEnumItemValue'
			}),

			pagination: {
				set(data) {
					this.applySorting(data)
				},
				get() { return this.jobsPagination }
			},

			getJobPriority() {
				return (item) => {
					if (item.is_24_hour_rush) return '24Hr'

					let priority = this.getJobEnumItemValue('jobPriorities', item.priority, 'name')
					return (priority !== 'Standard' && priority !== 'Extended') ? priority : ''
				}
			},
		},

		methods: {
			...mapActions({
				applySorting:VUEX_JOBS_SYNC_PAGINATION,
				loadJob: VUEX_JOB_GET_REQUEST,
			}),

			findEnumValue(needle, haystack) {
				let idx = haystack.findIndex(x => x.id === needle)
				if (idx < 0) return ''
				return haystack[idx]['name']
			},

			hasViewed(viewed_status) {
				if (viewed_status === false) return 'custom-vcard'
				return ''
			},

			/* determineRoute(item){
				let state = this.getApprovalStatus(item)
				if (!state) {
					this.$router.push({ name: 'job-drawer-stream', params: { jobId: item.id } })
				} else {
					this.$router.push({ name: 'job-drawer-approval', params: { jobId: item.id } })
				}
			}, */

			loadJobRequest(item, state) {
				if (state !== "draft" && (this.currentUserHasPerm(SILA_PERMISSION_JOBS_JOB_EXEC_APPROVE) || this.currentUserHasPerm(SILA_PERMISSION_JOBS_JOB_PRINT_APPROVE))) {
					this.$router.push({ name:'job-overview', params:{ jobId: item.id } })
				} else {
					// Removed for mobile
                    // this.loadDraft({ id })
				}
			},

			getApprovalStatus(item) {
				switch(item.state) {
					case 'pending_print_approval' :
					case 'pending_print_reapproval' :
						return 'print'
                    case 'pending_package_approval' :
                    case 'pending_package_reapproval' :
                        return 'package'
					case 'pending_exec_approval' :
					case 'pending_exec_reapproval' :
						return 'exec'
					default :
						return null
				}
			},
		}
	}
</script>

<style>
.break {
	word-break: break-all;
}
</style>
